function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#ffe3f3"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 11,
  width: 18,
  height: 18,
  fill: "url(#pattern0)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 11,
  width: 18,
  height: 18,
  fill: "url(#pattern1)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_2269_13391",
  transform: "scale(0.00195312)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern1",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image1_2269_13391",
  transform: "scale(0.00195312)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_2269_13391",
  width: 512,
  height: 512,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAJ4SURBVEiJ7ZY7aBRRFIa/czYiBAVJlc1qKQgWChYhWNjY2CWF0Ug0T0kwhQg+GmcdsxaiqAET4yPRqBixUcFKELURgiimU7A02UmTRpIoZmeOxWbN3btbKNjp6ebjm8t/7nDuXAHIkz0I7BNYEHSonnAKr/JkWwTrNCgYqdEM4QvfmSHYpuhJSOqAJ2lytyQiO2Aw7HjLhjVmyH0ogYig1ZBHjmOK7q4nfFkCXzi9OYVOA7WOFqhBvxdkDUiPCwzxHYmxPhekSB0qXxxA+hUQv1UQj1mFIxWs0gFUgXEPxorc9ZjvGOjtcpQ8AL573pgYSERwGGS/wALo5TThaz/KLNk2gS6gYDCaYfCZ78wRNCbIKWDlI38c9p3/VVFihDpH0mdYM8h8gl7YSDjtiyvD2Aa2aDCUIffGd2YJdgpyFGy9wMM0uXsSkT1jEDreUkyyfRPnPpdARHDEkBHHKYA2NRC+Ww0Q7ACZAmp+pccG1KBsYIBaJdXuNeo7NZB0e06Pu3jpPfXb/NulwJjHvkE86YKk0okFnXDBynPsMsPGxdibitgyALSAzIOed/e2KCJ5gi5FDoAtQupKtWGMCHYZckxgXYJNNpC78yfd/qMlBjJHtt+wVoMFJXWp2v7mCdoF6TRs2ZBr1Q67GYImLR52G8Cepvl0VSKC44ZcdLyKIYrIdhhMOI4BexoYfL7qBFsNeQ+sdaSzakivF6RGsA4XGPR4jhjSXe5ou7s4gECvFhOXl2Gxhyoc+Q0HiNXghgd/xN7fqoqTCHqzDCD3gSXPuy6wem0Bvgo6lCZ860fJEzZD0gkUBEbSDL7yneK1RU4AdWCP0+TGfwKpOONsnr4yOAAAAABJRU5ErkJggg=="
}), /*#__PURE__*/React.createElement("image", {
  id: "image1_2269_13391",
  width: 512,
  height: 512,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAJ4SURBVEiJ7ZY7aBRRFIa/czYiBAVJlc1qKQgWChYhWNjY2CWF0Ug0T0kwhQg+GmcdsxaiqAET4yPRqBixUcFKELURgiimU7A02UmTRpIoZmeOxWbN3btbKNjp6ebjm8t/7nDuXAHIkz0I7BNYEHSonnAKr/JkWwTrNCgYqdEM4QvfmSHYpuhJSOqAJ2lytyQiO2Aw7HjLhjVmyH0ogYig1ZBHjmOK7q4nfFkCXzi9OYVOA7WOFqhBvxdkDUiPCwzxHYmxPhekSB0qXxxA+hUQv1UQj1mFIxWs0gFUgXEPxorc9ZjvGOjtcpQ8AL573pgYSERwGGS/wALo5TThaz/KLNk2gS6gYDCaYfCZ78wRNCbIKWDlI38c9p3/VVFihDpH0mdYM8h8gl7YSDjtiyvD2Aa2aDCUIffGd2YJdgpyFGy9wMM0uXsSkT1jEDreUkyyfRPnPpdARHDEkBHHKYA2NRC+Ww0Q7ACZAmp+pccG1KBsYIBaJdXuNeo7NZB0e06Pu3jpPfXb/NulwJjHvkE86YKk0okFnXDBynPsMsPGxdibitgyALSAzIOed/e2KCJ5gi5FDoAtQupKtWGMCHYZckxgXYJNNpC78yfd/qMlBjJHtt+wVoMFJXWp2v7mCdoF6TRs2ZBr1Q67GYImLR52G8Cepvl0VSKC44ZcdLyKIYrIdhhMOI4BexoYfL7qBFsNeQ+sdaSzakivF6RGsA4XGPR4jhjSXe5ou7s4gECvFhOXl2Gxhyoc+Q0HiNXghgd/xN7fqoqTCHqzDCD3gSXPuy6wem0Bvgo6lCZ860fJEzZD0gkUBEbSDL7yneK1RU4AdWCP0+TGfwKpOONsnr4yOAAAAABJRU5ErkJggg=="
}));

function SvgIconBoxWidgetsMenuNotKbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxWidgetsMenuNotKbank);
export default __webpack_public_path__ + "static/media/icon_box-widgets-menu-notKBANK.a18dd50d.svg";
export { ForwardRef as ReactComponent };